import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import './ProductReview.css';
import { createPortal } from 'react-dom';

// 🟢 NAYA COMPONENT: Sirf ek individual review ko handle karne ke liye (Text See More ke liye)
const SingleReviewCard = ({ rev, setZoomImage }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 150; // Agar review text isse bada hoga, toh "See More" dikhega

  const needsExpansion = rev.comment.length > maxLength;

  return (
    <div className="review-card">
      <div className="review-header">
        <span className="review-user">{rev.user}</span>
      </div>
      <div className="review-stars">
        {[...Array(5)].map((_, i) => (
          <i key={i} className={`fa-star ${i < rev.rating ? "fa-solid" : "fa-regular"}`}></i>
        ))}
      </div>
      
      <p className="review-text">
        {isExpanded || !needsExpansion 
          ? rev.comment 
          : `${rev.comment.substring(0, maxLength)}...`}
        
        {needsExpansion && (
          <span 
            onClick={() => setIsExpanded(!isExpanded)}
            style={{
              color: '#000',
              fontWeight: 'bold',
              cursor: 'pointer',
              marginLeft: '5px',
              fontSize: '0.85rem',
              textDecoration: 'underline'
            }}
          >
            {isExpanded ? "Show Less" : "See More"}
          </span>
        )}
      </p>

      <div className="review-images-grid">
        {[rev.image1, rev.image2, rev.image3, rev.image4].map((imgData, index) => {
          if (!imgData) return null; 
          const imgSrc = `data:image/jpeg;base64,${imgData}`;
          return (
            <img 
              key={index} src={imgSrc} alt="Review" className="review-thumb"
              onClick={() => setZoomImage(imgSrc)}
            />
          );
        })}
      </div>
    </div>
  );
};

const ProductReview = ({ productId }) => {
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [email, setEmail] = useState(""); 
  const [emailError, setEmailError] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]); 
  const [user, setUser] = useState(null);
  
  const [zoomImage, setZoomImage] = useState(null);

  // Shuruwat mein kitne review dikhane hain (Default: 2)
  const [visibleReviewsCount, setVisibleReviewsCount] = useState(2);

  const navigate = useNavigate();

  // ==========================================
  // 🟢 YEH RAHA MAGIC FIX: Background Scroll Lock
  // ==========================================
  useEffect(() => {
    if (zoomImage) {
      // Jab image zoom ho, background scroll band kar do
      document.body.style.overflow = 'hidden';
    } else {
      // Jab image close ho, scroll wapas normal kar do
      document.body.style.overflow = 'unset';
    }

    // Cleanup (agar user page chhod de toh scroll band na reh jaye)
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [zoomImage]);
  // ==========================================

  // Check Login Status
  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) setUser(JSON.parse(savedUser));
  }, []);

  // Load Reviews from Database
  useEffect(() => {
    if(!productId) return;
    
    fetch(`https://antarvaani.com/api/reviews/product/${productId}`)
      .then(res => res.json())
      .then(data => setReviews(data))
      .catch(err => console.error("Error loading reviews:", err));
  }, [productId]);

  // Handle Image Selection
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 4) {
      alert("You can only upload a maximum of 4 images.");
      e.target.value = ""; 
      return;
    }
    setSelectedImages(files);
  };

  // Submit Review Logic
  const handleSubmit = (e) => {
    e.preventDefault();
    setEmailError(false); 
    
    if (rating === 0 || comment.trim() === "") { 
        alert("Rating and Comment required."); 
        return; 
    }

    if (!user && email.trim() === "") {
        setEmailError(true); 
        return;
    }

    const formData = new FormData();
    formData.append("user", user ? user.username : email);
    formData.append("rating", rating);
    formData.append("comment", comment);
    formData.append("productId", productId);
    
    selectedImages.forEach((file) => {
      formData.append("images", file);
    });

    fetch("https://antarvaani.com/api/reviews/add", {
      method: "POST",
      body: formData 
    })
    .then(res => res.json())
    .then(newReview => {
      setReviews([newReview, ...reviews]);
      
      setRating(0);
      setComment("");
      setEmail("");
      setEmailError(false);
      setSelectedImages([]); 
      if (document.getElementById("fileInput")) {
          document.getElementById("fileInput").value = ""; 
      }
      
      alert("Review Submitted Successfully!");
    })
    .catch(err => console.error("Error submitting review:", err));
  };

  return (
    <div className="review-section">
      <h3 className="section-title-small">Customer Reviews ({reviews.length})</h3>

      {zoomImage && createPortal(
        <div className="image-modal-overlay" onClick={() => setZoomImage(null)}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-modal" onClick={() => setZoomImage(null)}>&times;</span>
            <img src={zoomImage} alt="Zoomed Review" />
          </div>
        </div>,
        document.body // 🟢 Yeh line is popup ko sabse upar fek degi!
      )}

      {/* --- Review Form Section --- */}
      <div className="review-form-box">
        <h4>Write a Review</h4>
        
        <div className="star-rating-input">
          {[1, 2, 3, 4, 5].map((star) => (
            <i 
              key={star} 
              className={`fa-star ${star <= rating ? "fa-solid active" : "fa-regular"}`} 
              onClick={() => setRating(star)}
            ></i>
          ))}
        </div>
        
        <textarea 
          placeholder="How was the product?" 
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        ></textarea>

        {!user && (
          <div style={{ marginBottom: '15px' }}>
            <input 
              type="email" 
              placeholder="Enter your email" 
              value={email}
              onChange={(e) => {
                  setEmail(e.target.value);
                  if(e.target.value !== "") setEmailError(false);
              }}
              style={{ 
                  width: '100%', 
                  padding: '12px', 
                  borderRadius: '4px', 
                  border: emailError ? '2px solid #ff4d4d' : '1px solid #ddd', 
                  marginTop: '10px',
                  outline: 'none',
                  fontSize: '0.9rem'
              }}
              required
            />
            
            {emailError && (
                <p style={{ color: '#ff4d4d', fontSize: '0.75rem', marginTop: '5px', fontWeight: 'bold' }}>
                    ⚠️ Please enter your email address to submit the review.
                </p>
            )}

            <p style={{ fontSize: '0.85rem', color: '#666', marginTop: '10px' }}>
              Want a faster checkout experience?{' '}
              <span 
                onClick={() => navigate('/login')} 
                style={{ color: 'black', fontWeight: 'bold', cursor: 'pointer', textDecoration: 'underline' }}
              >
                Login / Sign in
              </span>
            </p>
          </div>
        )}

        <div className="file-upload-wrapper">
            <label style={{fontWeight:'bold', display:'block', marginBottom:'5px', fontSize: '0.9rem'}}>Add Photos (Max 4): </label>
            <input 
              id="fileInput"
              type="file" 
              accept="image/*" 
              multiple 
              onChange={handleImageChange} 
            />
            {selectedImages.length > 0 && (
              <p style={{fontSize:'0.8rem', color:'green', marginTop:'5px'}}>
                {selectedImages.length} images selected
              </p>
            )}
        </div>

        <button className="btn-submit-review" onClick={handleSubmit}>
          SUBMIT REVIEW
        </button>
      </div>

      {/* --- Reviews List Display --- */}
      <div className="reviews-list">
        {reviews.length === 0 && <p style={{color:'#777'}}>No reviews yet.</p>}
        
        {/* Sirf 'visibleReviewsCount' tak hi review dikhenge */}
        {reviews.slice(0, visibleReviewsCount).map((rev) => (
          <SingleReviewCard key={rev.id} rev={rev} setZoomImage={setZoomImage} />
        ))}

        {/* 'See All' aur 'Show Less' logic */}
        {reviews.length > 2 && (
          <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '2px' }}>
            {visibleReviewsCount < reviews.length ? (
              <button 
                onClick={() => setVisibleReviewsCount(reviews.length)} 
                style={{
                  backgroundColor: '#000',
                  border: '1px solid #000',
                  color: '#fff',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  borderRadius: '4px',
                  fontSize: '0.9rem',
                  textTransform: 'uppercase',
                  transition: 'all 0.3s ease'
                }}
              >
                See All {reviews.length} Reviews
              </button>
            ) : (
              <button 
                onClick={() => setVisibleReviewsCount(2)} 
                style={{
                  backgroundColor: '#000',
                  color: '#fff',
                  border: '1px solid #000',
                  padding: '10px 20px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  borderRadius: '4px',
                  fontSize: '0.9rem',
                  textTransform: 'uppercase',
                  transition: 'all 0.3s ease'
                }}
              >
                Show Less
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductReview;